import type { PayloadAction } from '@reduxjs/toolkit';
import type { CampaignEditorReducerCreator } from '../types';

const deleteBlock = (create: CampaignEditorReducerCreator) =>
  create.reducer((state, action: PayloadAction<string>) => {
    if (state.blocks) state.blocks = state.blocks.filter((block) => block.id !== action.payload);
    if (state.selectedBlockId === action.payload) state.selectedBlockId = null;
  });

export default deleteBlock;
